import { render, staticRenderFns } from "./PinnedCampaignsTable.vue?vue&type=template&id=5092768e"
import script from "./PinnedCampaignsTable.vue?vue&type=script&lang=js"
export * from "./PinnedCampaignsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports